const accountLang = {
  en: {
    profile: "Profile",
    myProfile: "My profile",
    settingProfile: "Account settings",
    profileOverview: "Overview",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    details: "Details",
    editProfile: "Edit profile",
    user_no_authorized: "The credentials are wrong",
    fullName: "Full name",
    phone: "Phone number",
    user: "User",
    solvency: "Solvency",
    profileDetails: "Profile details",
    nit: "NIT",
    fullNameRequired: "Full name is a required field",
    phoneRequired: "Phone nombre is a required field",
    nitRequired: "NIT is a required field",
    user_updated_successful: "User has updated correctly",
    updatePassword: "Update password",
    labelPassword: "The password must contain at least 8 characters",
    auth: "Authentication",
    resetPassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    newPasswordRequired: "New password is a required field",
    confirmNewPasswordRequired: "Confirm new password is a required field",
    passwordMustMatch: "Password does not match",
    user_password_error: "Please, complete the required fields",
    user_current_password_error: "The current password is wrong",
    user_password_updated_successful: "Your password has updated correctly",
    attentionReport: "Attention Report",
    selectDateRange: "Select date range",
    month: "Month",
    generate: "Generate",
    totalPersons : "Total persons",
    totalActivities : "Total activities",
    totalPlanification  : "Total planification",
    pendingRequests  : "Pending requests",
    planningVsExecution  : "Planning and execution of goals",
    allMonths  : "All months",
    allDepartments  : "All departments",
    allPrograms  : "All programs",
    allActivities  : "All activities",
    executed  : "Executed",
    percentage  : "Percentage",
    byActivity  : "By activity",
    byDepartment  : "By department",
    monthlyTrend  : "Monthly trend",
    currentYear  : "Current year",
    selectYears  : "Select years",
    selectMonths  : "Select months",
    selectDepartments  : "Select departments",
    selectPrograms  : "Select programs",
    selectActivities  : "Select activities",
    planOperativoAnual: "Annual Operative Plan (POA)",
    totalPlanificado: "Total planned",
    byStrategicAxis: "By strategic axis",
    byProgram: "By program",
    monthlyDistribution: "Monthly distribution",
    errorLoadingPoaData: "Error loading POA data",
    
    // Administrative Module
    administrativeModule: "Administrative module", 
    administrativeOverview: "General indicators and activities",
    administrativeActivitiesByStatus: "Administrative activities by status",
    administrativeActivitiesByMonth: "Administrative activities by month",
    assetsDistribution: "Assets distribution",
    errorLoadingAdminData: "Error loading administrative data",
    
    // Population Module  
    populationModule: "Population module",
    populationAnalysis: "Analysis and demographics",
    populationServedEvolution: "Evolution of population served",
    populationServedQuantity: "Quantity of population served",
    activitiesByType: "Activities by type",
    demographicDistribution: "Demographic distribution",
    errorLoadingPopulationData: "Error loading population data",
    
    // Budget Module
    budgetAnalysis: "Budget analysis",
    budgetDistribution: "Distribution and execution",
    budgetByCategory: "Budget by category",
    budgetVsExecuted: "Budget vs executed",
    errorLoadingBudgetData: "Error loading budget data",
    
    // Execution Module
    executionAnalysis: "Execution analysis",
    executionOverview: "Requests and liquidations",
    requestsByStatus: "Requests by status",
    monthlyLiquidations: "Monthly liquidations",
    personnelByDepartment: "Personnel by department",
    errorLoadingExecutionData: "Error loading execution data",
    
    // Human Talent Module
    humanTalentModule: "Human talent module",
    humanResourcesAnalysis: "HR and recruitment analysis",
    applicantsByStatus: "Applicants by status",
    collaboratorsByDepartment: "Collaborators by department",
    staffTurnover: "Staff turnover",
    errorLoadingTalentData: "Error loading talent data",
    
    // General
    error: "Error",
    selectYear: "Select year",
    planned: "Planned",
    loaded: "Loaded",
    refreshData: "Refresh data"
  },
  es: {
    profile: "Perfil",
    myProfile: "Mi perfil",
    settingProfile: "Ajustes de perfil",
    profileOverview: "Descripción general",
    account: "Cuenta",
    accountOverview: "Descripción general",
    settings: "Ajustes",
    details: "Detalles",
    editProfile: "Editar mi perfil",
    user_no_authorized: "Las credenciales son incorrectas",
    fullName: "Nombre completo",
    phone: "Número telefónico",
    user: "Usuario",
    solvency: "Solvencia",
    profileDetails: "Detalles de perfil",
    nit: "NIT",
    fullNameRequired: "Nombre completo es un campo requerido",
    phoneRequired: "Número telefónico es un campo requerido",
    nitRequired: "NIT es un campo requerido",
    user_updated_successful: "Usuario se ha actualizado correctamente",
    updatePassword: "Actualizar contraseña",
    labelPassword: "La contraseña debe contener al menos 8 caracteres",
    auth: "Autenticación",
    resetPassword: "Cambiar contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    newPasswordRequired: "Nueva contraseña es un campo requerido",
    confirmNewPasswordRequired:
      "Confirmar nueva contraseña es un campo requerido",
    passwordMustMatch: "La contraseña no coincide",
    user_password_error: "Por favor, completar los campos requeridos",
    user_current_password_error: "La contraseña actual es incorrecta",
    user_password_updated_successful:
      "Su contraseña ha sido actualizada correctamente",
    attentionReport: "Reporte de atenciones",
    selectDateRange: "Seleccionar período",
    month: "Mes",
    generate: "Generar",
    totalPersons : "Total de personas",
    totalActivities : "Total de actividades",
    totalPlanification  : "Total de planificación",
    pendingRequests  : "Solicitudes pendientes",
    planningVsExecution  : "Planificación y ejecución de metas",
    allMonths  : "Todos los meses",
    allDepartments  : "Todos los departamentos",
    allPrograms  : "Todos los programas",
    allActivities  : "Todas las actividades",
    executed  : "Ejecutado",
    percentage  : "Porcentaje",
    byActivity  : "Por actividad",
    byDepartment  : "Por departamento",
    monthlyTrend  : "Tendencia mensual",
    currentYear  : "Año actual",
    selectYears  : "Seleccione años",
    selectMonths  : "Seleccione meses",
    selectDepartments  : "Seleccione departamentos",
    selectPrograms  : "Seleccione programas",
    selectActivities  : "Seleccione actividades",
    planOperativoAnual: "Plan Operativo Anual (POA)",
    totalPlanificado: "Total planificado",
    byStrategicAxis: "Por eje estratégico",
    byProgram: "Por programa",
    monthlyDistribution: "Distribución mensual",
    errorLoadingPoaData: "Error al cargar datos del POA",
    
    // Administrative Module
    administrativeModule: "Módulo administrativo", 
    administrativeOverview: "Indicadores generales y actividades",
    administrativeActivitiesByStatus: "Actividades administrativas por estado",
    administrativeActivitiesByMonth: "Actividades administrativas por mes",
    assetsDistribution: "Distribución de activos",
    errorLoadingAdminData: "Error al cargar datos administrativos",
    
    // Population Module  
    populationModule: "Módulo de población",
    populationAnalysis: "Análisis y demografía",
    populationServedEvolution: "Evolución de población atendida",
    populationServedQuantity: "Cantidad de población atendida",
    activitiesByType: "Actividades por tipo",
    demographicDistribution: "Distribución demográfica",
    errorLoadingPopulationData: "Error al cargar datos de población",
    
    // Budget Module
    budgetAnalysis: "Análisis de presupuesto",
    budgetDistribution: "Distribución y ejecución",
    budgetByCategory: "Presupuesto por categoría",
    budgetVsExecuted: "Presupuesto vs ejecutado",
    errorLoadingBudgetData: "Error al cargar datos de presupuesto",
    
    // Execution Module
    executionAnalysis: "Análisis de ejecución",
    executionOverview: "Solicitudes y liquidaciones",
    requestsByStatus: "Solicitudes por estado",
    monthlyLiquidations: "Liquidaciones mensuales",
    personnelByDepartment: "Personal por departamento",
    errorLoadingExecutionData: "Error al cargar datos de ejecución",
    
    // Human Talent Module
    humanTalentModule: "Módulo de talento humano",
    humanResourcesAnalysis: "Análisis de RRHH y reclutamiento",
    applicantsByStatus: "Aplicantes por estado",
    collaboratorsByDepartment: "Colaboradores por departamento",
    staffTurnover: "Rotación de personal",
    errorLoadingTalentData: "Error al cargar datos de talento",
    
    // General
    error: "Error",
    selectYear: "Seleccione año",
    planned: "Planificado",
    loaded: "Cargado",
    refreshData: "Actualizar datos"
  },
};
export default accountLang;
